import { createContext, useContext } from "react";
import { createDxpClickHandler } from "../../../Helpers/utils";

/** Page context for DXP static pages (RichText interpolation, template links). */
export const DxpStandalonePageContext = createContext<Record<
  string,
  unknown
> | null>(null);

/** Optional click handler for Link/Button `redirect.actionType`. */
export const DxpClickHandlerContext = createContext<ReturnType<
  typeof createDxpClickHandler
> | null>(null);

export function useDxpClickHandlerFromContext() {
  const ctx = useContext(DxpClickHandlerContext);
  return ctx ?? createDxpClickHandler();
}
